import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { type VehicleFormSchema, vehicleFormSchema } from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { VehicleForm } from "@/forms/vehicle-form";
import { client } from "@/hono";

/** Props Interface */
interface AddVehicleModalProps extends ModalProps {
	onComplete: () => Promise<void>;
}

export function AddVehicleModal({ isOpen, onClose, onComplete }: AddVehicleModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(vehicleFormSchema),
	});

	/** Functions */
	async function handleOnSubmit(json: VehicleFormSchema) {
		try {
			await client.vehicles.index.$post({ json });
			await onComplete();
			onClose();
			methods.reset();
		} catch (error) {
			console.error(error);
		}
	}

	function handleOnReject(errors: typeof methods.formState.errors) {
		console.error(errors);
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={methods.handleSubmit(handleOnSubmit, handleOnReject)}
				isLoading={methods.formState.isSubmitting}
				title={t("vehicles.add_vehicle")}
				data-cy="vehicle-form"
			>
				<Modal.Body>
					<VehicleForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
